module.exports = {"svg":{"$":{"viewBox":"0 0 253 168","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"path":[{"$":{"d":"M94.8776538 167.944962 1.40642308 74.5463077 9.90184615 66.0646154 94.8776538 150.981577 245.096192 0.747346154 253.593577 9.24276923z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-check.svg
// module id = 493
// module chunks = 0